import React, {useMemo} from 'react';
import {ThemeProvider} from 'styled-components';

export type Direction = 'ltr' | 'rtl';

interface DirectionProviderProps {
    direction: Direction;
    children: React.ReactNode;
}

export function DirectionProvider({direction, children}: DirectionProviderProps) {
    const themeValue = useMemo(() => ({direction}), [direction]);
    
    return (
        <ThemeProvider theme={themeValue}>
            {children}
        </ThemeProvider>
    );
}
